/**
* Stats JS
* -----------------------------------------------------------------------------
*
* All the JS for the Stats component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'stats',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
    },
    finalize: function() {
      $( this.selector() ).each( function() {
        const $container = $( this );
        const $stats = $container.find( '.stat-box' );

        ScrollTrigger.create( {
          trigger: $container,
          start: 'top 50%',
          onEnter: () => {
            $stats.each( ( index, stat ) => {
              gsap.delayedCall( index * 0.3, () => {
                $( stat ).addClass( 'in-view' );
              } );
            } );
          },
        } );
      } );
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'stats', COMPONENT );
} )( app );
